import './HomeAbout.css';
import homeAboutImage from '../../../assets/images/home__about-image.webp';
import homeAboutIcon1 from '../../../assets/icons/homeAboutIcon1.png';
import homeAboutIcon2 from '../../../assets/icons/homeAboutIcon2.png';
import homeAboutIcon3 from '../../../assets/icons/homeAboutIcon3.png';
import homeAboutIcon4 from '../../../assets/icons/homeAboutIcon4.png';

const HomeAbout = () => {
  return (
    <section className='home__about'>
        <div className="home__about-content">
            <div className="home__about-content-texts">
                <h2 className="home__about-content-title mont-m">
                Наше производство 
                </h2>
                <p className="home__about-content-text int-r-21">
                В портфолио Домановского маслосырзавода — две торговые марки: известна более 20 лет ТМ «Pastoral», и молодая демократическая ТМ «Мумуля».
                </p>
                <p className="home__about-content-text int-r-21">
                Если хочется провести вечер изысканно – выбирайте Pastoral: авторские сыры, десерты, йогурты, сливочное масло по французской рецептуре. А когда нужно вкусно и полезно накормить всю семью – присоединяйтесь к сообществу Мумуля.
                </p>
                <p className="home__about-content-text int-r-21">
                Продукция завода - натуральная, проверенная, безопасная для детей, на ней выросло не одно поколение украинцев - мы поставляем молочные продукты в детские сады, школы, больницы и санатории.
                </p>
            </div>
                <img src={homeAboutImage} alt="pastoral логотип" className="home__about-content-image" />
        </div>
        <div className="home__about-cards">
            <div className="home__about-card">
                <img src={homeAboutIcon1} alt="Фермерская продукция" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Фермерская продукция</p>
            </div>
            <div className="home__about-card second">
                <img src={homeAboutIcon2} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">20 лет на рынке</p>
            </div>
            <div className="home__about-card">
                <img src={homeAboutIcon3} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Опыт работы с HoReCa</p>
            </div>
            <div className="home__about-card">
                <img src={homeAboutIcon4} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Тендерные поставки</p>
            </div>
            
        </div>
    </section>
  )
}

export default HomeAbout